import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { map } from 'rxjs/operators';

@Injectable()
export class ResumoGuiasRedePropriaService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getData(regans: string, competenciaInicial: string, competenciaFinal: string) {
    return this.simuladorGoApi
      .fetchResumoGuiasRedePropria({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
      })
      .pipe(map(data => data.items));
  }

  getListagemGuiasRedePropria(
    regans: string,
    competenciaInicial: string,
    competenciaFinal: string,
    cnpj: string,
    origem_guia?: string,
    tipo_rede?: string,
    cnes?: string,
    tipo_guia?: number,
  ) {
    return this.simuladorGoApi
      .fetchListagemGuiasRedePropria({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
        cnpj,
        origem_guia,
        tipo_rede,
        cnes,
        tipo_guia,
      })
      .pipe(map(data => data.items));
  }

  getFiliaisAtivas(regans: string) {
    return this.simuladorGoApi
      .fetchResumoGuiasRedePropriaFiliais({
        regans,
      })
      .pipe(map(data => data.items));
  }

  getFiliaisAtivasUltimoProcessamento(regans: string) {
    return this.simuladorGoApi
      .fetchResumoGuiasRedePropriaFiliaisUltimoProcessamento({ regans })
      .pipe(map(data => data.items?.[0]?.dt_atualizacao_mon_guia ?? null));
  }
}
